import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import api from "../utils/api";
import { Bookmark, Trash2, ArrowLeft, Play } from "lucide-react";

/**
 * Chain Templates Page — list + delete. Create/edit happens inline from the
 * Chain Reconciliation Wizard (via "Save as template"). This page is the
 * index view where admins manage existing templates.
 */
export default function ChainTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    api.get("/chain-templates").then(r => setTemplates(r.data || [])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const onDelete = async (t) => {
    if (!window.confirm(`Delete template "${t.name}"?`)) return;
    await api.delete(`/chain-templates/${t.id}`);
    load();
  };

  return (
    <Layout>
      <div className="animate-in" style={{ maxWidth: "900px", margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
          <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)" }}><ArrowLeft size={18} /></button>
          <h1 style={{ fontFamily: "Bricolage Grotesque, sans-serif", fontWeight: 600, fontSize: "1.5rem", margin: 0, display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Bookmark size={18} style={{ color: "#0EA5E9" }} /> Chain Templates
          </h1>
        </div>

        <div className="recon-card" style={{ padding: "1rem 1.25rem" }}>
          {loading && <div style={{ color: "var(--text-muted)", padding: "1rem" }}>Loading…</div>}
          {!loading && templates.length === 0 && (
            <div data-testid="chain-templates-empty" style={{ textAlign: "center", padding: "2rem 1rem", color: "var(--text-muted)" }}>
              No templates yet. Head to <b>Chain Reconciliation</b> and click "Save as template" after configuring a run.
            </div>
          )}
          {!loading && templates.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              {templates.map(t => (
                <div key={t.id} data-testid={`chain-tpl-row-${t.id}`} style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.65rem 0.9rem", background: "#f9fafb", borderRadius: "0.4rem" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600 }}>{t.name}</div>
                    {t.description && <div style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>{t.description}</div>}
                    <div style={{ fontSize: "0.7rem", color: "var(--text-muted)", marginTop: "0.15rem" }}>
                      {(t.legs || []).length} hop{(t.legs || []).length === 1 ? "" : "s"} · branch cap {t.branch_cap || 1} · created {String(t.created_at || "").slice(0, 10)}
                    </div>
                  </div>
                  <button data-testid={`chain-tpl-use-${t.id}`} title="Use this template"
                    onClick={() => navigate("/chain-reconcile")} className="btn-secondary" style={{ fontSize: "0.78rem", padding: "0.3rem 0.7rem", display: "flex", alignItems: "center", gap: "0.3rem" }}>
                    <Play size={12} /> Use
                  </button>
                  <button data-testid={`chain-tpl-del-${t.id}`} onClick={() => onDelete(t)}
                    className="btn-secondary" style={{ fontSize: "0.78rem", padding: "0.3rem 0.6rem", color: "#dc2626", display: "flex", alignItems: "center", gap: "0.25rem" }}>
                    <Trash2 size={12} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
